import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  loadStateFromLocalStorage,
  saveStateToLocalStorage,
} from "./locationSliceTypes";

interface LocationStateTypes {
  locationStateData: any | null;
  traditionalQuoteData: any | null;
}

const initialState: LocationStateTypes = {
  locationStateData: loadStateFromLocalStorage(),
  traditionalQuoteData: null,
};

const locationSlice = createSlice({
  name: "locationState",
  initialState,
  reducers: {
    setLocationData: (state, action: PayloadAction<any | null>) => {
      state.locationStateData = action.payload;
      saveStateToLocalStorage(state.locationStateData);
    },
    setTraditionalQuoteData: (state, action: PayloadAction<any | null>) => {
      state.traditionalQuoteData = action.payload;
    },
    clearTraditionalQuoteData: (state) => {
      state.traditionalQuoteData = null;
    },
  },
});

export const { setLocationData, setTraditionalQuoteData, clearTraditionalQuoteData } = locationSlice.actions;

export default locationSlice.reducer;
